import { ReactNode, createRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './styles.module.css';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

const popUpContainerId = 'app-popup-container';
const container = document.createElement('div');
container.setAttribute('date-js-popup-container', '');
const containerRef = createRef<HTMLDivElement>();
const ToastPopUpContainer = () => {
  return (
    <>
      <div
        id={popUpContainerId}
        className={styles.container}
        ref={containerRef}
      ></div>
    </>
  );
};

type ToastPopUpProps = { children: ReactNode };
export const ToastPopUp = ({ children }: ToastPopUpProps) => {
  const [open, setOpen] = useState(true);
  return (
    <>
      {createPortal(
        <>
          <div className={classNames(styles.popup, !open && styles.close)}>
            <button
              type="button"
              onClick={() => setOpen(!open)}
              className={styles.opener}
            >
              <FontAwesomeIcon
                icon={!open ? faAngleLeft : faAngleRight}
                className={styles.icon}
              />
            </button>
            <div className={styles.content}>{children}</div>
          </div>
        </>,
        containerRef.current || container,
        'popup'
      )}
    </>
  );
};

export default ToastPopUpContainer;
